module.exports = __webpack_public_path__ + "b970228a09fee8f4c60611b3c27e0694.png";